module.exports = __webpack_public_path__ + "static/media/refresh.ae01565d.svg";